module.exports = __webpack_public_path__ + "img/clipboards-black.5c492b46.svg";